/* The section includes this asset once per instance, so a bare top-level
   class declaration throws on the second copy. Guard on the registry. */
if (!customElements.get('featured-collection')) {
  class FeaturedCollection extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('slider-component');
      if (!this.slider) return;

      this.progressBar = this.querySelector('[data-slider-progress-bar]');
      this.externalArrows = this.querySelectorAll('[data-slider-arrow]');
      this.innerPrev = this.slider.querySelector('.slider-buttons button[name="previous"]');
      this.innerNext = this.slider.querySelector('.slider-buttons button[name="next"]');

      this.bindArrows();
      this.observeButtonState();
      this.slider.addEventListener('slideChanged', this.updateProgress.bind(this));
      this.updateProgress();
    }

    bindArrows() {
      if (!this.externalArrows.length) return;
      this.externalArrows.forEach((button) => {
        const target = button.dataset.sliderArrow === 'previous' ? this.innerPrev : this.innerNext;
        if (!target) return;
        button.addEventListener('click', () => target.click());
      });
    }

    observeButtonState() {
      if (!this.innerPrev || !this.innerNext) return;
      const sync = () => {
        this.externalArrows.forEach((button) => {
          const target = button.dataset.sliderArrow === 'previous' ? this.innerPrev : this.innerNext;
          if (!target) return;
          button.toggleAttribute('disabled', target.hasAttribute('disabled'));
        });
      };
      const observer = new MutationObserver(sync);
      observer.observe(this.innerPrev, { attributes: true, attributeFilter: ['disabled'] });
      observer.observe(this.innerNext, { attributes: true, attributeFilter: ['disabled'] });
      sync();
    }

    updateProgress() {
      if (!this.progressBar) return;
      const currentElement = this.slider.querySelector('.slider-counter--current');
      const totalElement = this.slider.querySelector('.slider-counter--total');
      const current = parseInt(currentElement?.textContent || '1', 10);
      const total = parseInt(totalElement?.textContent || '1', 10);
      const percent = total > 0 ? (current / total) * 100 : 100;
      this.progressBar.style.setProperty('--progress', `${percent}%`);
    }
  }

  customElements.define('featured-collection', FeaturedCollection);
}
